import React from 'react';

const JS_Chart_js = () => {
  return (
    <div >
      <h1>JS_Chart_js</h1>
      <p>Placeholder component for: "JS Chart.js"</p>
    </div>
  );
};

export default JS_Chart_js;
